import React, { useEffect, useLayoutEffect, useState, useRef, useCallback, useMemo } from 'react'
import Spinner from '../../utils/spinner/Spinner'
import { FaSearch, FaTimes } from 'react-icons/fa';
import { WS_ENDPOINT_PLATFORM_LIVE_FEEDS, WS_ENDPOINT_SYMBOLS_LIVE_FEEDS } from "../../../data/Endpoints-WS";
import { ws_create } from "../../../data/websocket/Websocket-Middleware";
import { useSymbolContext } from "../../../contexts/Symbol-Context";
import { useAuthContext } from '../../../contexts/Auth-Context';
import { useChartContext } from '../../../contexts/Chart-Context';
import { API_ENDPOINT_SYMBOLS } from '../../../data/Endpoints-API';
import { API_ENDPOINT_USER_WATCHLIST } from '../../../data/Endpoints-API';
import { API_ENDPOINT_INSERT_WATCHLIST } from '../../../data/Endpoints-API';
import { API_ENDPOINT_DELETE_WATCHLIST } from '../../../data/Endpoints-API';
import './Symbol.scss'
import APIMiddleware from '../../../data/api/Api-Middleware';
import Select from 'react-select';
import { Ripple } from 'react-ripple-click';
import 'react-ripple-click/dist/index.css';
import StarSvg from './StarSvg';
import { VariableSizeList as List } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';
import { translateCategoryName } from '../../../i18n/categoryLabel';
import { useTranslation } from 'react-i18next';
import TabIndicator from '../../utils/TabIndicator.jsx';

// Stable component identity preserves the hovered/pressed DOM row across price ticks.
function StableSymbolRow({ data, ...row }) {
    return data(row);
}

function AnimatedSymbolGroup({ open, children }) {
    const nodeRef = useRef(null);
    const frozenChildren = useRef(children);
    const animating = useRef(false);
    const [, refresh] = useState(0);
    if (!animating.current) frozenChildren.current = children;
    const [mounted, setMounted] = useState(open);
    const targetHeight = open ? Number(children.props.style.height) || 0 : 0;
    useLayoutEffect(() => {
        const node = nodeRef.current;
        const from = node.getBoundingClientRect().height;
        if (open) setMounted(true);
        const finish = () => { node.style.height = targetHeight + 'px'; animating.current = false; refresh(value => value + 1); if (!open) setMounted(false); };
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { finish(); return; }
        animating.current = true;
        const animation = node.animate([{ height: from + 'px' }, { height: targetHeight + 'px' }],
            { duration: 220, easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'forwards' });
        animation.finished.then(finish).catch(() => {});
        return () => { node.style.height = node.getBoundingClientRect().height + 'px'; animation.cancel(); animating.current = false; };
    }, [open, targetHeight]);
    return <div ref={nodeRef} className="symbol-category-reveal" aria-hidden={!open}>
        <div className="symbol-category-clip">{(open || mounted) ? frozenChildren.current : null}</div>
    </div>;
}

// Quote spread in price units, rounded to the precision of the input quotes.
function formatSpread(quote) {
    if (quote?.ask == null || quote?.bid == null || quote.ask === '' || quote.bid === '') return '-';
    const ask = Number(quote.ask), bid = Number(quote.bid);
    if (!Number.isFinite(ask) || !Number.isFinite(bid)) return '-';
    const precision = value => {
        const [mantissa, exponent = '0'] = String(value).toLowerCase().split('e');
        return Math.max(0, (mantissa.split('.')[1]?.length || 0) - Number(exponent));
    };
    return (ask - bid).toFixed(Math.min(20, Math.max(precision(quote.ask), precision(quote.bid))));
}

const Symbol = () => {
    const { t } = useTranslation();

    //Tabs  
    const [activeMode, setActiveMode] = useState('symbols');
    const [symbolCategory,setSymbolCategory] = useState(() => {
        const symbolCategoryLocal = localStorage.getItem(`symbolCategory`);
        return symbolCategoryLocal ? symbolCategoryLocal: "Forex";
    });
    const [symbolCategoryId,setSymbolCategoryId] = useState(() => {
        const symbolCategoryIdLocal = localStorage.getItem(`symbolCategoryID`);
        return symbolCategoryIdLocal ? symbolCategoryIdLocal: "1";
    });
    // Track which categories are open (for WatchLists to show all)
    const [openCategories, setOpenCategories] = useState(new Set());


      
      
    //start click
    const [watchlistSymbols, setWatchlistSymbols] = useState({});

      
    const handleTdClick = (symbol) => {
        // Toggle the clicked status for the specific symbol
        setWatchlistSymbols((prevClickedSymbols) => ({
            ...prevClickedSymbols,
            [symbol]: !prevClickedSymbols[symbol],
        }));

        // Check the clicked status to determine whether to insert or delete watchlist data
        if (!watchlistSymbols[symbol]) {
            // If the symbol is not selected (clicked), insert it into the watchlist
            insertWatchlist(symbol);
        } else {
            // If the symbol is already selected (clicked), delete it from the watchlist
            deleteWatchlist(symbol);
        }
    };
 
    const starBoolean = (e) => {
        if (e.target.tagName == 'path') {
            if (e.target.parentNode.getAttribute('bool') == 'false') {
                e.target.parentNode.setAttribute('bool', true);
            } else {
                e.target.parentNode.setAttribute('bool', false);
            }
        } else {
            if (e.target.children[0].getAttribute('bool') == 'false') {
                e.target.children[0].setAttribute('bool', true);
            } else {
                e.target.children[0].setAttribute('bool', false);
            }
        }
    }

        //CONTEXT
    const { loadingSymbolContext, symbolData, symbolNames,  updateSymbolData, loadAllSymbolsData, updateSymbolDetailsData, symbolDetails, symbolWithCategories, symbolCategories, setSelectedCategoryId, allSymbolOptions,selectedSymbolSession, setSelectedSymbolSession } = useSymbolContext();
    const { user, platFromData, sendDataToServer, selectedAuthSymbol, setAuthSelectedSymbol,setAuthSelectedCategory,authSelectedCategory,selectedAuthSymbolId,setSelectedAuthSymbolId ,isWebSocketRefetch} = useAuthContext();
    const { selectedTimeFrame, selectedStyle } = useChartContext();
    
    //everything must be initialize before further processing, so block everything base on this flag state
    const [isInitialized, setIsInitialized] = useState(false);

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 960);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 960);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);


    const [searchInput, setSearchInput] = useState('');
    const [keyboardSymbol, setKeyboardSymbol] = useState(null);
    const [pendingSymbol, setPendingSymbol] = useState(null);
    const virtualLists = useRef(new Map());
    useEffect(() => {
        const ready = event => setPendingSymbol(current => current === event.detail?.symbol ? null : current);
        window.addEventListener('symbol-chart-ready', ready);
        return () => window.removeEventListener('symbol-chart-ready', ready);
    }, []);
    useEffect(() => {
        if (!pendingSymbol) return;
        const timeout = setTimeout(() => setPendingSymbol(null), 15000);
        return () => clearTimeout(timeout);
    }, [pendingSymbol]);
    const [closedSearchCategories, setClosedSearchCategories] = useState(new Set());
    const toggleSearchCategory = (name) => {
        setClosedSearchCategories(previous => {
            const next = new Set(previous);
            if (next.has(name)) next.delete(name); else next.add(name);
            return next;
        });
    };
    // Replace the localStorage-based initialization with simple state
    const [paginationStart, setPaginationStart] = useState(0);
    const [paginationLimit] = useState(100); // Fixed limit of 100 items per page
    const [totalSymbols, setIsTotalSymbols] =  useState();
    const getDescriptionTooltip = useCallback((description) => {
        if (!description) return '';
        const maxChars = isMobile ? 28 : 54;
        return description.length > maxChars ? description : '';
    }, [isMobile]);

    const debounceRef = useRef(null);

    const listRef = useRef(null);
    const isFetchingRef = useRef(false);
    const categoryInitializedRef = useRef(false);

    const SYMBOL_ROW_HEIGHT_WITH_DESC = 44;
    const SYMBOL_ROW_HEIGHT_NO_DESC = 30;

    const hasSymbolDescription = useCallback((data) => {
        const desc = data?.description;
        return typeof desc === 'string' && desc.trim().length > 0;
    }, []);

    const getSymbolRowHeight = useCallback((data) => {
        return hasSymbolDescription(data) ? SYMBOL_ROW_HEIGHT_WITH_DESC : SYMBOL_ROW_HEIGHT_NO_DESC;
    }, [hasSymbolDescription]);

    const getVirtualListHeight = useCallback((entries) => {
        const maxHeight = Math.max(220, Math.round(window.innerHeight * 0.45));
        const list = entries || [];
        const contentHeight = list.reduce((sum, [, d]) => sum + getSymbolRowHeight(d), 0);
        return Math.min(maxHeight, Math.max(SYMBOL_ROW_HEIGHT_WITH_DESC, contentHeight));
    }, [getSymbolRowHeight]);
  

    useEffect(() => {
      if (listRef.current) listRef.current.scrollTop = 0;
      
           if (activeMode !== 'watchlists'){
                sendDataToServer({
            type: 'SymbolsPagination',
            paginationStart: 0,
            paginationEnd: 100,
            category: symbolCategoryId,
        });
           }
      
    }, [symbolCategoryId,isWebSocketRefetch]);

 

    const changeSymbolCategory = (e, o) => {
        if (o === false) {
            const categories = symbolCategories?.find((category) => category.name === e);
            if (!categories) return; // Guard against undefined category
            
            // Update state immediately
            setSymbolCategory(e);
            setSymbolCategoryId(categories.id);
            
            // Save category ID to localStorage when in 'All Symbols' mode
            if (activeMode === 'symbols') {
                localStorage.setItem('symbolCategory', e);
                localStorage.setItem('symbolCategoryID', categories.id.toString());
            }
            
            setIsTotalSymbols(symbolWithCategories.filter((symbol) => 
                symbol.symbol_category === categories.id
            ).length);
            
            // Reset pagination when changing category
            setPaginationStart(0);
        } else {
            setSymbolCategory(null);
        }
    };

    // Handle category toggle for WatchLists
    const toggleWatchlistCategory = (categoryName) => {
        setOpenCategories(prev => {
            const newSet = new Set(prev);
            if (newSet.has(categoryName)) {
                newSet.delete(categoryName);
            } else {
                newSet.add(categoryName);
            }
            return newSet;
        });
    };

    const handleSearchChange = useCallback((e) => {
        const value = e;
        setSearchInput(value);
        setKeyboardSymbol(null);
        setClosedSearchCategories(new Set());

        if (debounceRef.current) clearTimeout(debounceRef.current);

        debounceRef.current = setTimeout(() => {
            if (value.length > 0) {
                sendDataToServer({
                    type: 'SearchSymbols',
                    searchInput: value,
                });
            } else {
                setSymbolCategory(null);
            }
        }, 500);
    }, [symbolCategoryId, paginationLimit]);

    //create web-socket instance for the component
    const ws_symbol = ws_create();
    const WS_MESSAGE_EVENT_LISTENER = "ws_message_platform";

    const [watchlistData, setWatchlistData] = useState([]);
    let isSymbolDetailsUpdated = false;

    useEffect(() => {
        if (selectedAuthSymbol != '') {
            localStorage.setItem('prevSymbol', localStorage.symbol);
            localStorage.setItem('symbol', selectedAuthSymbol);
            localStorage.setItem('category',authSelectedCategory);
        }
    }, [selectedAuthSymbol])

    useEffect(() => {
      if(selectedAuthSymbolId != ''){
            localStorage.setItem('symbol_id', selectedAuthSymbolId);
        }
    }, [selectedAuthSymbolId])
    useEffect(() => {
        if (user && user.userId != undefined && user.userId > 0) {
            //nothing will load in this component until SymbolContext fully loaded 
            if (!loadingSymbolContext) {
                //everything must be initialize before further processing, so block everything base on this flag state
                if (!isInitialized) {
                    const getSymbols = () => {
                        try {
                            const initialSymbolData = {};
                            const savedStart = parseInt(localStorage.getItem(`paginationStart_${symbolCategory}`)) || 0;
                            const savedLimit = parseInt(localStorage.getItem(`paginationLimit_${symbolCategory}`)) || 10;
                            setIsTotalSymbols( symbolWithCategories.filter((symbol)=>symbol.symbol_category==symbolCategoryId).length);
                            
                            symbolWithCategories.forEach((symbol) => {
                                
                                initialSymbolData[symbol.name] = {id:symbol.id, ask: symbol.initial_ask_price, bid: symbol.initial_bid_price, spread: null, ask_class: 'Symbol-price-same', bid_class: 'Symbol-price-same', symbol_category: symbol.symbol_category, is_session_active: symbol.is_session_active, description: symbol.description || null, asset_class_id: symbol.asset_class_id };
                                });
                            //set symbol initial list data
                            loadAllSymbolsData(initialSymbolData);
    
                            if (localStorage.symbol == null) {
                                updateSymbolDetailsData(symbolNames[0]);
                            } else {
                                updateSymbolDetailsData(localStorage.symbol);
                            }
    
                            //everything must be initialize before further processing, so block everything base on this flag state
                            setIsInitialized(true);

                            getWatchlistdata();

                        } catch (error) {
                            // Handle API request error
                            console.error(`API request error: ${API_ENDPOINT_SYMBOLS}`, error);
                        }
                    }
    
                    //load symbols in list
                    getSymbols();
                }

                //once everything initialized then further process base on this flag state
                if (isInitialized && platFromData.length > 0  && !platFromData[3]?.keepPrevData && platFromData[0] != undefined && platFromData[0] != 'undefined'&& Object.keys(platFromData[0]).length > 0) {
                    //update list with updated live feed
                    const updateLiveFeedData = () => {
                        const updatedSymbolData = platFromData[0];
                        let selectedSymbol=platFromData[8]?.symbol;
                        if(selectedSymbol?.name==selectedAuthSymbol){
                        updateSymbolData(selectedSymbol?.name,selectedSymbol.ea,selectedSymbol.eb,selectedSymbol?.bid, selectedSymbol?.ask, selectedSymbol?.is_session_active);
            
                    }
                        loadAllSymbolsData(updatedSymbolData);
                    };
                    updateLiveFeedData();

                    return async () => {
                    };
                }
            }
        }

    }, [loadingSymbolContext, isInitialized, selectedAuthSymbol, user, selectedTimeFrame,symbolCategory, platFromData[0]]);

    useEffect(() => {
        // Only set initial category once when categories are first loaded
        if (symbolCategories?.length && !categoryInitializedRef.current) {
            const savedCategory = localStorage.getItem('symbolCategory');
            const savedCategoryExists = savedCategory && symbolCategories.find(cat => cat.name === savedCategory);
            
            if (savedCategoryExists) {
                // Restore saved category
                const category = symbolCategories.find(cat => cat.name === savedCategory);
                setSymbolCategory(savedCategory);
                setSymbolCategoryId(category.id.toString());
            } else if (symbolCategories.length > 0) {
                // Set to first category
                setSymbolCategory(symbolCategories[0].name);
                setSymbolCategoryId(symbolCategories[0].id.toString());
                localStorage.setItem('symbolCategory', symbolCategories[0].name);
                localStorage.setItem('symbolCategoryID', symbolCategories[0].id.toString());
            }
            categoryInitializedRef.current = true;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [symbolCategories?.length]);

    const getWatchlistdata = async () => {
        try {
            // Use the API_ENDPOINT_USER_WATCHLIST in the fetch request
            const response = await APIMiddleware.get(API_ENDPOINT_USER_WATCHLIST(user.userId));

            if (response.data) {
                const symbols = response.data;
                setWatchlistSymbols(() => {
                    // Use reduce to iterate over the symbols array and create an object with true values
                    const updatedSymbols = symbols.reduce((acc, symbol) => {
                        acc[symbol.name] = true;
                        return acc;
                    }, {});

                    return updatedSymbols;
                });

            }
        } catch (error) {
            console.error('Error fetching watchlist data:', error);
        }
    };

    const insertWatchlist = async (symbol) => {
        try {
            // Call the API endpoint that triggers the stored procedure
            await APIMiddleware.post(API_ENDPOINT_INSERT_WATCHLIST(user.userId, symbol));
        } catch (error) {
            console.error('Error inserting watchlist item:', error);
        }
    };

    const deleteWatchlist = async (symbol) => {
        try {
            // Call the API endpoint that triggers the stored procedure for deletion
            await APIMiddleware.post(API_ENDPOINT_DELETE_WATCHLIST(user.userId, symbol));
            console.log('Watchlist item deleted successfully.');
        } catch (error) {
            console.error('Error deleting watchlist item:', error);
        }
    };

    // Filter symbols based on the search input
    const filteredSymbols = Object.keys(symbolData).filter((symbol) => {
        const query = searchInput.toLowerCase();
        const description = symbolData[symbol]?.description?.toLowerCase?.() || '';
        return symbol.toLowerCase().includes(query) || description.includes(query);
    });

    //handle symbols list row clicks
    const handleRowClick = (symbolName,symbolData) => {
        if (!symbolData[symbolName]) return;
        if (symbolName !== selectedAuthSymbol) setPendingSymbol(symbolName);
        // Update symbol context data when a row is clicked      
        updateSymbolData(symbolName, symbolData[symbolName].ea, symbolData[symbolName].eb, symbolData[symbolName].bid, symbolData[symbolName].ask, symbolData[symbolName].is_session_active);
        setSelectedCategoryId(symbolData[symbolName].symbol_category);
        setAuthSelectedCategory(symbolData[symbolName].symbol_category);
        setAuthSelectedSymbol(symbolName);
           
        setSelectedAuthSymbolId(symbolData[symbolName]?.id);
    };

    const handleSearchKeyDown = event => {
        if (event.key === 'Escape') { event.preventDefault(); handleSearchChange(''); return; }
        if (event.key === 'Enter' && keyboardSymbol) { event.preventDefault(); handleRowClick(keyboardSymbol, symbolData); return; }
        if (!['ArrowDown', 'ArrowUp'].includes(event.key)) return;
        const matches = (symbolCategories || []).flatMap(category => filteredSymbols.filter(name =>
            Number(symbolData[name]?.symbol_category) === Number(category.id) &&
            (activeMode !== 'watchlists' || watchlistSymbols[name])));
        if (!matches.length) return;
        event.preventDefault();
        const index = matches.indexOf(keyboardSymbol);
        const next = matches[index < 0 ? (event.key === 'ArrowDown' ? 0 : matches.length - 1) : Math.max(0, Math.min(matches.length - 1, index + (event.key === 'ArrowDown' ? 1 : -1)))];
        setKeyboardSymbol(next);
        const category = symbolCategories.find(c => Number(c.id) === Number(symbolData[next]?.symbol_category));
        if (!category) return;
        setClosedSearchCategories(previous => { const updated = new Set(previous); updated.delete(category.name); return updated; });
        if (!searchInput) {
            if (activeMode === 'watchlists') setOpenCategories(previous => new Set([...previous, category.name]));
            else changeSymbolCategory(category.name, false);
        }
        requestAnimationFrame(() => {
            const rows = matches.filter(name => Number(symbolData[name]?.symbol_category) === Number(category.id));
            virtualLists.current.get(category.id)?.scrollToItem(rows.indexOf(next), 'smart');
        });
    };

    const SymbolPanelClass = activeMode === 'symbols' ? 'visible' : 'hidden';
    const WatchListClass = activeMode === 'watchlists' ? 'visible' : 'hidden';

 
    const handleModeClick = (mode) => {
        setActiveMode(mode);
        setSearchInput("");
        if (mode === 'watchlists') {
            // Only open categories that actually have watchlist symbols
            const watchlistCategoryNames = new Set();
            Object.entries(symbolData || {}).forEach(([sym, data]) => {
                if (!watchlistSymbols[sym]) return;
                const cat = symbolCategories?.find((c) => Number(c.id) === Number(data?.symbol_category));
                if (cat?.name) watchlistCategoryNames.add(cat.name);
            });
            setOpenCategories(watchlistCategoryNames);
            setSymbolCategory(null); // Clear single category selection
            
            const watchlistSymbolsArray = Object.keys(watchlistSymbols).filter(symbol => watchlistSymbols[symbol]);
            sendDataToServer({
                type: 'watchlist',
                watchlistSymbols: watchlistSymbolsArray,
            });
        } else {
            // When switching to 'All Symbols', open the dropdown for the category saved in localStorage
            const savedCategory = localStorage.getItem('symbolCategory');
            if (savedCategory) {
                setSymbolCategory(savedCategory);
            } else {
                setSymbolCategory(null);
            }
            setOpenCategories(new Set()); // Clear open categories set
        }
    };

    const categoriesToRender = useMemo(() => {
        const cats = symbolCategories || [];
        if (activeMode === 'watchlists') {
            return cats.filter((cat) => {
                return Object.entries(symbolData || {}).some(([sym, data]) => {
                    if (!watchlistSymbols[sym]) return false;
                    if (Number(data?.symbol_category) !== Number(cat.id)) return false;
                    if (searchInput && searchInput.trim().length > 0) {
                        return filteredSymbols.includes(sym);
                    }
                    return true;
                });
            });
        }

        if (searchInput && searchInput.trim().length > 0) {
            return cats.filter((cat) => {
                return Object.entries(symbolData || {}).some(([sym, data]) => {
                    return Number(data?.symbol_category) === Number(cat.id) && filteredSymbols.includes(sym);
                });
            });
        }

        return cats;
    }, [symbolCategories, activeMode, symbolData, watchlistSymbols, searchInput, filteredSymbols]);

    return (
        <div className='global-platfrom mobile-styled' style={{ height: 'calc(100% - 70px)' }}>
            {/* Tab section */}
            <div className="symbol-mode-tabs global-platfrom ">
                <TabIndicator activeKey={activeMode} />
                <button
                    data-active={activeMode === 'symbols'}
                    className={`mode-tab-button ${activeMode === 'symbols' ? 'mode-tab-active' : ''}`}
                    onClick={() => {
                        handleModeClick('symbols');
                        sendDataToServer({type: 'selectedSymbolChange',selectedSymbolName: selectedAuthSymbol,selectedSymbolTimeFrame: selectedTimeFrame,selectedCategory: authSelectedCategory});
                    }}
                >
                    {t('symbol.allSymbols')}
                </button>
                <button
                    data-active={activeMode === 'watchlists'}
                    className={`mode-tab-button ${activeMode === 'watchlists' ? 'mode-tab-active' : ''}`}
                    onClick={() => {
                        handleModeClick('watchlists');
                    }}
                    disabled={!isWebSocketRefetch}
                >
                    {t('symbol.watchLists')}
                </button>
            </div>
            <div className={`Symbol ${SymbolPanelClass} symbol-panel-parent`}>
                <div className="Symbol global-platfrom symbol-panel-height" >
                    {/* Search input */}
                    <div className="search-container">
                        <FaSearch className="search-icon" />
                        <input
                            type="text"
                            placeholder={t('symbol.searchPlaceholder')}
                            disabled={!isWebSocketRefetch}
                            value={searchInput}
                            onKeyDown={handleSearchKeyDown}
                            onChange={(e) =>handleSearchChange(e.target.value)}
                            className='input-symbol-field'
                        />
                        {searchInput && (
                            <FaTimes
                                className="clear-icon-symbol"
                                disabled={!isWebSocketRefetch}
                                onClick={() => handleSearchChange('')}
                            />
                        )}
                    </div>
                    <div className=''>
                        <table className="Symbol-table-head">
                            <thead className="Symbol-table-thead">
                                <th className='star-th'></th>
                                <th className='session-th'></th>
                                <th className='symbol-th'>{t('tables.symbol')}</th>
                                <th className='bid-th'>{t('symbol.bid')}</th>
                                <th className='ask-th'>{t('symbol.ask')}</th>
                                <th className='spread-th'>{t('symbol.spread', 'Spread')}</th>
                            </thead>
                        </table>
                    </div>
                    
                    <div className="Symbol-list" ref={listRef}>
                        {searchInput && categoriesToRender.length === 0 && <div className="symbol-empty" role="status">No matching symbols</div>}

                        {categoriesToRender?.map((category) => {
                            const categorySymbolEntries = Object.entries(symbolData).filter(([sym, d]) =>
                                d.symbol_category === category.id && filteredSymbols.includes(sym)
                            );
                            return (
                            searchInput.length === 0 ?
                            <wrapper key={category.id}>
                                <heading onClick={()=>{changeSymbolCategory(category.name,symbolCategory === category.name ? true : false)}} >
                                    <div className='indicator' >
                                    <svg className="symbol-category-chevron" viewBox="0 0 16 16" aria-hidden="true" style={{
                                        transform: symbolCategory === category.name ? 'rotate(90deg)' : 'none',
                                    }} >
                                    <path d="m6 3 5 5-5 5" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                    </div>  
                                    {translateCategoryName(category.name, t)}{searchInput && <span className="symbol-result-count">{filteredSymbols.filter(name => Number(symbolData[name]?.symbol_category) === Number(category.id) && (activeMode !== 'watchlists' || watchlistSymbols[name])).length}</span>}
                                </heading>
                                
                                <AnimatedSymbolGroup open={symbolCategory === category.name}><div
                                        className="Symbol-list-virtual"
                                        style={{
                                            height: getVirtualListHeight(categorySymbolEntries)
                                        }}
                                    >
                                        <AutoSizer>
                                            {({ height, width }) => (
                                            <List ref={instance => { if (instance) virtualLists.current.set(category.id, instance); }} 
                                            className="symbol-react-window-list"
                                            key={`${symbolCategoryId}-${paginationStart}`}
                                            height={height}
                                            width={width}
                                            itemCount={categorySymbolEntries.length}
                                            itemSize={(index) => {
                                                const row = categorySymbolEntries[index];
                                                return row ? getSymbolRowHeight(row[1]) : SYMBOL_ROW_HEIGHT_WITH_DESC;
                                            }}
                                            estimatedItemSize={38}
                                            itemKey={(index) => categorySymbolEntries[index]?.[0] ?? index}
                                            onItemsRendered={({ visibleStartIndex, visibleStopIndex }) => {
                                                if (activeMode !== 'symbols' || symbolCategory !== category.name) return;
                                                sendDataToServer({
                                                    type: 'SymbolsPagination',
                                                    paginationStart: visibleStartIndex,
                                                    paginationEnd: visibleStopIndex+5,
                                                    category: symbolCategoryId,
                                                });
                                        
                                            }}
                                         itemData={({ index, style }) => {
                                                const [symbol, data] = categorySymbolEntries[index] || [];
                                                const isSelected = selectedAuthSymbol === symbol;

                                                if (!data) return null;

                                                return (
                                                    <div
                                                        className={`Symbol-tr ${!hasSymbolDescription(data) ? 'symbol-row-no-desc' : ''} ${isSelected ? 'selected-row' : ''} ${keyboardSymbol === symbol ? 'keyboard-row' : ''}`}
                                                        style={{
                                                            ...style,
                                                            display: 'flex',
                                                            alignItems: hasSymbolDescription(data) ? 'flex-start' : 'center',
                                                            width: '100%'
                                                        }}
                                                    >
                                                        <StarSvg 
                                                            handleTdClick={handleTdClick} 
                                                            symbol={symbol} 
                                                            watchlistSymbols={watchlistSymbols[symbol] || false}
                                                        >
                                                            {t('symbol.addToWatchlist')}
                                                        </StarSvg>

                                                        <div className={`specific-td session-td`}>
                                                            {pendingSymbol === symbol ? <span className="symbol-loading" role="status" aria-label="Loading chart" /> : data.is_session_active === 0 ? (
                                                                <div className='pause-mark'>||</div>
                                                            ) : (
                                                                <div className='check-mark'>
                                                                    <svg
                                                                        id='checkmarkId'
                                                                        width={16}
                                                                        height={16}
                                                                        viewBox="0 0 24 24"
                                                                        fill={selectedStyle.buyColor}
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                    >
                                                                        <path d="M9 19.4l-7-7L3.4 10 9 15.6 20.6 4 22 5.4z" />
                                                                    </svg>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div
                                                            className="Symbol-td symbol-td enclp2 symbol-name-cell"
                                                            data-tooltip={!isMobile && symbol.length > 7 ? symbol : undefined}
                                                            onClick={() => handleRowClick(symbol, symbolData)}
                                                            style={{
                                                                position: 'relative',
                                                                isolation: 'isolate',
                                                            }}
                                                        >
                                                            <Ripple />
                                                            <div className='symbol-name-text'>{symbol}</div>
                                                        </div>
                                                        <div
                                                            className={`Symbol-td ${data.bid_class} bid-td`}
                                                            onClick={() => handleRowClick(symbol, symbolData)}
                                                            style={{
                                                                color:
                                                                data.bid_class === 'Symbol-price-up'
                                                                    ? selectedStyle.buyColor
                                                                    : data.bid_class === 'Symbol-price-down'
                                                                    ? selectedStyle.sellColor
                                                                    : 'white',
                                                                position: 'relative',
                                                                overflow: 'hidden',
                                                                isolation: 'isolate',
                                                                textOverflow: 'ellipsis',
                                                                
                                                            }}
                                                        >
                                                            <Ripple />
                                                            {data.bid
                                                                ? data.bid
                                                        
                                                                : '-'}
                                                        </div>
                                                        <div
                                                            className={`Symbol-td ${data.ask_class} ask-td`}
                                                            onClick={() => handleRowClick(symbol, symbolData)}
                                                            data-full-text={data.ask ?? '-'}
                                                            style={{
                                                                color:
                                                                data.bid_class === 'Symbol-price-up'
                                                                    ? selectedStyle.buyColor
                                                                    : data.bid_class === 'Symbol-price-down'
                                                                    ? selectedStyle.sellColor
                                                                    : 'white',
                                                                position: 'relative',
                                                                overflow: 'hidden',
                                                                isolation: 'isolate',
                                                                textOverflow: 'ellipsis',
                                                                    
                                                            }}
                                                        >
                                                            <Ripple />
                                                            {data.ask
                                                                ? data.ask
                                                                : '-'}
                                                        </div>
                                                            <div className="Symbol-td spread-td" title={formatSpread(data)}>{formatSpread(data)}</div>
                                                        {data.description ? (
                                                            <div
                                                                className='symbol-row-description'
                                                                data-tooltip={getDescriptionTooltip(data.description) || undefined}
                                                                onClick={() => handleRowClick(symbol, symbolData)}
                                                            >
                                                                {data.description}
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                );
                                            }}>
                                            {StableSymbolRow}
                                        </List>
                                            )}
                                        </AutoSizer>
                                    </div></AnimatedSymbolGroup>
                            </wrapper> :
                            <wrapper key={category.id}>
                                <heading onClick={() => toggleSearchCategory(category.name)}>
                                    <div className='indicator' >
                                        <svg className="symbol-category-chevron" viewBox="0 0 16 16" aria-hidden="true" style={{
                                            transform: closedSearchCategories.has(category.name) ? 'none' : 'rotate(90deg)',
                                        }}>
                                            <path d="m6 3 5 5-5 5" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </div>
                                    {translateCategoryName(category.name, t)}{searchInput && <span className="symbol-result-count">{filteredSymbols.filter(name => Number(symbolData[name]?.symbol_category) === Number(category.id) && (activeMode !== 'watchlists' || watchlistSymbols[name])).length}</span>}
                                </heading>

                                {/* Use the SAME virtual list renderer during search for consistent layout */}
                                <AnimatedSymbolGroup open={!closedSearchCategories.has(category.name)}><div
                                    className="Symbol-list-virtual"
                                    style={{
                                        height: getVirtualListHeight(categorySymbolEntries)
                                    }}
                                >
                                    <AutoSizer>
                                        {({ height, width }) => (
                                            <List ref={instance => { if (instance) virtualLists.current.set(category.id, instance); }} 
                                                className="symbol-react-window-list"
                                                height={height}
                                                width={width}
                                                itemCount={categorySymbolEntries.length}
                                                itemSize={(index) => {
                                                    const row = categorySymbolEntries[index];
                                                    return row ? getSymbolRowHeight(row[1]) : SYMBOL_ROW_HEIGHT_WITH_DESC;
                                                }}
                                                estimatedItemSize={38}
                                                itemKey={(index) => categorySymbolEntries[index]?.[0] ?? index}
                                             itemData={({ index, style }) => {
                                                    const [sym, d] = categorySymbolEntries[index] || [];
                                                    const isSelected = selectedAuthSymbol === sym;
                                                    if (!d) return null;

                                                    return (
                                                        <div
                                                            className={`Symbol-tr ${!hasSymbolDescription(d) ? 'symbol-row-no-desc' : ''} ${isSelected ? 'selected-row' : ''} ${keyboardSymbol === sym ? 'keyboard-row' : ''}`}
                                                            style={{
                                                                ...style,
                                                                display: 'flex',
                                                                alignItems: hasSymbolDescription(d) ? 'flex-start' : 'center',
                                                                width: '100%'
                                                            }}
                                                        >
                                                            <StarSvg
                                                                handleTdClick={handleTdClick}
                                                                symbol={sym}
                                                                watchlistSymbols={watchlistSymbols[sym] || false}
                                                            >
                                                                {t('symbol.addToWatchlist')}
                                                            </StarSvg>

                                                            <div className={`specific-td session-td`}>
                                                                {pendingSymbol === sym ? <span className="symbol-loading" role="status" aria-label="Loading chart" /> : d.is_session_active === 0 ? (
                                                                    <div className='pause-mark'>||</div>
                                                                ) : (
                                                                    <div className='check-mark'>
                                                                        <svg
                                                                            id='checkmarkId'
                                                                            width={16}
                                                                            height={16}
                                                                            viewBox="0 0 24 24"
                                                                            fill={selectedStyle.buyColor}
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                        >
                                                                            <path d="M9 19.4l-7-7L3.4 10 9 15.6 20.6 4 22 5.4z" />
                                                                        </svg>
                                                                    </div>
                                                                )}
                                                            </div>

                                                            <div
                                                                className="Symbol-td symbol-td enclp2 symbol-name-cell"
                                                                data-tooltip={!isMobile && sym.length > 7 ? sym : undefined}
                                                                onClick={() => handleRowClick(sym, symbolData)}
                                                                style={{
                                                                    position: 'relative',
                                                                    isolation: 'isolate',
                                                                }}
                                                            >
                                                                <Ripple />
                                                                <div className='symbol-name-text'>{sym}</div>
                                                            </div>

                                                            <div
                                                                className={`Symbol-td ${d.bid_class} bid-td`}
                                                                onClick={() => handleRowClick(sym, symbolData)}
                                                                style={{
                                                                    color:
                                                                        d.bid_class === 'Symbol-price-up'
                                                                            ? selectedStyle.buyColor
                                                                            : d.bid_class === 'Symbol-price-down'
                                                                            ? selectedStyle.sellColor
                                                                            : 'white',
                                                                    position: 'relative',
                                                                    overflow: 'hidden',
                                                                    isolation: 'isolate',
                                                                    textOverflow: 'ellipsis',
                                                                }}
                                                            >
                                                                <Ripple />
                                                                {d.bid ? d.bid : '-'}
                                                            </div>

                                                            <div
                                                                className={`Symbol-td ${d.ask_class} ask-td`}
                                                                onClick={() => handleRowClick(sym, symbolData)}
                                                                data-full-text={d.ask ?? '-'}
                                                                style={{
                                                                    color:
                                                                        d.ask_class === 'Symbol-price-up'
                                                                            ? selectedStyle.buyColor
                                                                            : d.ask_class === 'Symbol-price-down'
                                                                            ? selectedStyle.sellColor
                                                                            : 'white',
                                                                    position: 'relative',
                                                                    overflow: 'hidden',
                                                                    isolation: 'isolate',
                                                                    textOverflow: 'ellipsis',
                                                                }}
                                                            >
                                                                <Ripple />
                                                                {d.ask ? d.ask : '-'}
                                                            </div>
                                                            <div className="Symbol-td spread-td" title={formatSpread(d)}>{formatSpread(d)}</div>

                                                            {d.description ? (
                                                                <div
                                                                    className='symbol-row-description'
                                                                    data-tooltip={getDescriptionTooltip(d.description) || undefined}
                                                                    onClick={() => handleRowClick(sym, symbolData)}
                                                                >
                                                                    {d.description}
                                                                </div>
                                                            ) : null}
                                                        </div>
                                                    );
                                                }}>
                                                {StableSymbolRow}
                                            </List>
                                        )}
                                    </AutoSizer>
                                </div></AnimatedSymbolGroup>
</wrapper>
                        );
                        })}
                    </div>
                </div>
            </div>
            <div className={`order-book-wrapper ${WatchListClass}`}>
                <div className="Symbol global-platfrom" style={{ height: '100%' }} >
                    {/* Search input */}
                    <div className="search-container">
                        <FaSearch className="search-icon" />
                        <input
                            type="text"
                            placeholder={t('symbol.searchPlaceholder')}
                            value={searchInput}
                            onKeyDown={handleSearchKeyDown}
                            disabled={!isWebSocketRefetch}
                            onChange={(e) =>handleSearchChange(e.target.value)}
                            className='input-symbol-field'
                        />
                        {searchInput && (
                            <FaTimes
                                className="clear-icon-symbol"
                                disabled={!isWebSocketRefetch}
                                onClick={() => handleSearchChange('')}
                            />
                        )}
                    </div>

                    {/* WATCH LIST TAB  */}

                    <div className=''>
                        <table className="Symbol-table-head">
                            <thead className="Symbol-table-thead">
                                <th className='star-th'></th>
                                <th className='session-th'></th>
                                <th className='symbol-th'>{t('tables.symbol')}</th>
                                <th className='bid-th'>{t('symbol.bid')}</th>
                                <th className='ask-th'>{t('symbol.ask')}</th>
                                <th className='spread-th'>{t('symbol.spread', 'Spread')}</th>
                            </thead>
                        </table>
                    </div>
                    
                    <div className="Symbol-list">
                        {searchInput && categoriesToRender.length === 0 && <div className="symbol-empty" role="status">No matching symbols</div>}
                        {categoriesToRender?.map((category) => {
                            const categoryWatchlistEntries = Object.entries(symbolData).filter(([sym, d]) =>
                                watchlistSymbols[sym] &&
                                d.symbol_category === category.id &&
                                filteredSymbols.includes(sym)
                            );
                            return (
                            searchInput.length === 0 ?
                            <wrapper key={category.id}>
                                <heading onClick={()=>{
                                    if (activeMode === 'watchlists') {
                                        toggleWatchlistCategory(category.name);
                                    } else {
                                        changeSymbolCategory(category.name, symbolCategory === category.name ? true : false);
                                    }
                                }} >
                                    <div className='indicator' >
                                    <svg className="symbol-category-chevron" viewBox="0 0 16 16" aria-hidden="true" style={{
                                        transform: activeMode === 'watchlists' 
                                            ? (openCategories.has(category.name) ? 'rotate(90deg)' : 'none')
                                            : (symbolCategory === category.name ? 'rotate(90deg)' : 'none'),
                                    }}>
                                    <path d="m6 3 5 5-5 5" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                    </div>  
                                    {translateCategoryName(category.name, t)}{searchInput && <span className="symbol-result-count">{filteredSymbols.filter(name => Number(symbolData[name]?.symbol_category) === Number(category.id) && (activeMode !== 'watchlists' || watchlistSymbols[name])).length}</span>}
                                </heading>
                                
                                <AnimatedSymbolGroup open={activeMode === 'watchlists' ? openCategories.has(category.name) : symbolCategory === category.name}><div
                                        className="Symbol-list-virtual"
                                        style={{
                                            height: getVirtualListHeight(categoryWatchlistEntries)
                                        }}
                                    >
                                        <AutoSizer>
                                            {({ height, width }) => (
                                                <List ref={instance => { if (instance) virtualLists.current.set(category.id, instance); }} 
                                                    className="symbol-react-window-list"
                                                    height={height}
                                                    width={width}
                                                    itemCount={categoryWatchlistEntries.length}
                                                    itemSize={(index) => {
                                                        const row = categoryWatchlistEntries[index];
                                                        return row ? getSymbolRowHeight(row[1]) : SYMBOL_ROW_HEIGHT_WITH_DESC;
                                                    }}
                                                    estimatedItemSize={38}
                                                    itemKey={(index) => categoryWatchlistEntries[index]?.[0] ?? index}
                                                 itemData={({ index, style }) => {
                                                        const [sym, d] = categoryWatchlistEntries[index] || [];
                                                        const isSelected = selectedAuthSymbol === sym;
                                                        if (!d) return null;

                                                        return (
                                                            <div
                                                                className={`Symbol-tr ${!hasSymbolDescription(d) ? 'symbol-row-no-desc' : ''} ${isSelected ? 'selected-row' : ''} ${keyboardSymbol === sym ? 'keyboard-row' : ''}`}
                                                                style={{
                                                                    ...style,
                                                                    display: 'flex',
                                                                    alignItems: hasSymbolDescription(d) ? 'flex-start' : 'center',
                                                                    width: '100%'
                                                                }}
                                                            >
                                                                <StarSvg
                                                                    handleTdClick={handleTdClick}
                                                                    symbol={sym}
                                                                    watchlistSymbols={watchlistSymbols[sym] || false}
                                                                >
                                                                    {t('symbol.removeFromWatchlist')}
                                                                </StarSvg>

                                                                <div className={`specific-td session-td`}>
                                                                    {pendingSymbol === sym ? <span className="symbol-loading" role="status" aria-label="Loading chart" /> : d.is_session_active === 0 ? (
                                                                        <div className='pause-mark'>||</div>
                                                                    ) : (
                                                                        <div className='check-mark'>
                                                                            <svg
                                                                                id='checkmarkId'
                                                                                width={16}
                                                                                height={16}
                                                                                viewBox="0 0 24 24"
                                                                                fill={selectedStyle.buyColor}
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                            >
                                                                                <path d="M9 19.4l-7-7L3.4 10 9 15.6 20.6 4 22 5.4z" />
                                                                            </svg>
                                                                        </div>
                                                                    )}
                                                                </div>

                                                                <div
                                                                    className="Symbol-td symbol-td enclp2 symbol-name-cell"
                                                                    data-tooltip={!isMobile && sym.length > 7 ? sym : undefined}
                                                                    onClick={() => handleRowClick(sym, symbolData)}
                                                                    style={{
                                                                        position: 'relative',
                                                                        isolation: 'isolate',
                                                                    }}
                                                                >
                                                                    <Ripple />
                                                                    <div className='symbol-name-text'>{sym}</div>
                                                                </div>

                                                                <div
                                                                    className={`Symbol-td ${d.bid_class} bid-td`}
                                                                    onClick={() => handleRowClick(sym, symbolData)}
                                                                    style={{
                                                                        color:
                                                                            d.bid_class === 'Symbol-price-up'
                                                                                ? selectedStyle.buyColor
                                                                                : d.bid_class === 'Symbol-price-down'
                                                                                ? selectedStyle.sellColor
                                                                                : 'white',
                                                                        position: 'relative',
                                                                        overflow: 'hidden',
                                                                        isolation: 'isolate',
                                                                        textOverflow: 'ellipsis',
                                                                    }}
                                                                >
                                                                    <Ripple />
                                                                    {d.bid ? d.bid : '-'}
                                                                </div>

                                                                <div
                                                                    className={`Symbol-td ${d.ask_class} ask-td`}
                                                                    onClick={() => handleRowClick(sym, symbolData)}
                                                                    data-full-text={d.ask ?? '-'}
                                                                    style={{
                                                                        color:
                                                                            d.ask_class === 'Symbol-price-up'
                                                                                ? selectedStyle.buyColor
                                                                                : d.ask_class === 'Symbol-price-down'
                                                                                ? selectedStyle.sellColor
                                                                                : 'white',
                                                                        position: 'relative',
                                                                        overflow: 'hidden',
                                                                        isolation: 'isolate',
                                                                        textOverflow: 'ellipsis',
                                                                    }}
                                                                >
                                                                    <Ripple />
                                                                    {d.ask ? d.ask : '-'}
                                                                </div>
                                                            <div className="Symbol-td spread-td" title={formatSpread(d)}>{formatSpread(d)}</div>

                                                                {d.description ? (
                                                                    <div
                                                                        className='symbol-row-description'
                                                                        data-tooltip={getDescriptionTooltip(d.description) || undefined}
                                                                        onClick={() => handleRowClick(sym, symbolData)}
                                                                    >
                                                                        {d.description}
                                                                    </div>
                                                                ) : null}
                                                            </div>
                                                        );
                                                    }}>
                                                    {StableSymbolRow}
                                                </List>
                                            )}
                                        </AutoSizer>
                                    </div></AnimatedSymbolGroup>
                            </wrapper> :
                            <wrapper>
                                <heading onClick={() => toggleSearchCategory(category.name)}>
                                    <div className='indicator' >
                                    <svg className="symbol-category-chevron" viewBox="0 0 16 16" aria-hidden="true" style={{
                                        transform: closedSearchCategories.has(category.name) ? 'none' : 'rotate(90deg)',
                                        }}>
                                    <path d="m6 3 5 5-5 5" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                    </div>  
                                    {translateCategoryName(category.name, t)}{searchInput && <span className="symbol-result-count">{filteredSymbols.filter(name => Number(symbolData[name]?.symbol_category) === Number(category.id) && (activeMode !== 'watchlists' || watchlistSymbols[name])).length}</span>}
                                </heading>
                                {/* Use the SAME virtual list renderer during search for consistent layout */}
                                <AnimatedSymbolGroup open={!closedSearchCategories.has(category.name)}><div
                                    className="Symbol-list-virtual"
                                    style={{
                                        height: getVirtualListHeight(categoryWatchlistEntries)
                                    }}
                                >
                                    <AutoSizer>
                                        {({ height, width }) => (
                                            <List ref={instance => { if (instance) virtualLists.current.set(category.id, instance); }} 
                                                className="symbol-react-window-list"
                                                height={height}
                                                width={width}
                                                itemCount={categoryWatchlistEntries.length}
                                                itemSize={(index) => {
                                                    const row = categoryWatchlistEntries[index];
                                                    return row ? getSymbolRowHeight(row[1]) : SYMBOL_ROW_HEIGHT_WITH_DESC;
                                                }}
                                                estimatedItemSize={38}
                                                itemKey={(index) => categoryWatchlistEntries[index]?.[0] ?? index}
                                             itemData={({ index, style }) => {
                                                    const [sym, d] = categoryWatchlistEntries[index] || [];
                                                    const isSelected = selectedAuthSymbol === sym;
                                                    if (!d) return null;

                                                    return (
                                                        <div
                                                            className={`Symbol-tr ${!hasSymbolDescription(d) ? 'symbol-row-no-desc' : ''} ${isSelected ? 'selected-row' : ''} ${keyboardSymbol === sym ? 'keyboard-row' : ''}`}
                                                            style={{
                                                                ...style,
                                                                display: 'flex',
                                                                alignItems: hasSymbolDescription(d) ? 'flex-start' : 'center',
                                                                width: '100%'
                                                            }}
                                                        >
                                                            <StarSvg
                                                                handleTdClick={handleTdClick}
                                                                symbol={sym}
                                                                watchlistSymbols={watchlistSymbols[sym] || false}
                                                            >
                                                                {t('symbol.removeFromWatchlist')}
                                                            </StarSvg>

                                                            <div className={`specific-td session-td`}>
                                                                {pendingSymbol === sym ? <span className="symbol-loading" role="status" aria-label="Loading chart" /> : d.is_session_active === 0 ? (
                                                                    <div className='pause-mark'>||</div>
                                                                ) : (
                                                                    <div className='check-mark'>
                                                                        <svg
                                                                            id='checkmarkId'
                                                                            width={16}
                                                                            height={16}
                                                                            viewBox="0 0 24 24"
                                                                            fill={selectedStyle.buyColor}
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                        >
                                                                            <path d="M9 19.4l-7-7L3.4 10 9 15.6 20.6 4 22 5.4z" />
                                                                        </svg>
                                                                    </div>
                                                                )}
                                                            </div>

                                                            <div
                                                                className="Symbol-td symbol-td enclp2 symbol-name-cell"
                                                                data-tooltip={!isMobile && sym.length > 7 ? sym : undefined}
                                                                onClick={() => handleRowClick(sym, symbolData)}
                                                                style={{
                                                                    position: 'relative',
                                                                    isolation: 'isolate',
                                                                }}
                                                            >
                                                                <Ripple />
                                                                <div className='symbol-name-text'>{sym}</div>
                                                            </div>

                                                            <div
                                                                className={`Symbol-td ${d.bid_class} bid-td`}
                                                                onClick={() => handleRowClick(sym, symbolData)}
                                                                style={{
                                                                    color:
                                                                        d.bid_class === 'Symbol-price-up'
                                                                            ? selectedStyle.buyColor
                                                                            : d.bid_class === 'Symbol-price-down'
                                                                            ? selectedStyle.sellColor
                                                                            : 'white',
                                                                    position: 'relative',
                                                                    overflow: 'hidden',
                                                                    isolation: 'isolate',
                                                                    textOverflow: 'ellipsis',
                                                                }}
                                                            >
                                                                <Ripple />
                                                                {d.bid ? d.bid : '-'}
                                                            </div>

                                                            <div
                                                                className={`Symbol-td ${d.ask_class} ask-td`}
                                                                onClick={() => handleRowClick(sym, symbolData)}
                                                                data-full-text={d.ask ?? '-'}
                                                                style={{
                                                                    color:
                                                                        d.ask_class === 'Symbol-price-up'
                                                                            ? selectedStyle.buyColor
                                                                            : d.ask_class === 'Symbol-price-down'
                                                                            ? selectedStyle.sellColor
                                                                            : 'white',
                                                                    position: 'relative',
                                                                    overflow: 'hidden',
                                                                    isolation: 'isolate',
                                                                    textOverflow: 'ellipsis',
                                                                }}
                                                            >
                                                                <Ripple />
                                                                {d.ask ? d.ask : '-'}
                                                            </div>
                                                            <div className="Symbol-td spread-td" title={formatSpread(d)}>{formatSpread(d)}</div>

                                                            {d.description ? (
                                                                <div
                                                                    className='symbol-row-description'
                                                                    data-tooltip={getDescriptionTooltip(d.description) || undefined}
                                                                    onClick={() => handleRowClick(sym, symbolData)}
                                                                >
                                                                    {d.description}
                                                                </div>
                                                            ) : null}
                                                        </div>
                                                    );
                                                }}>
                                                {StableSymbolRow}
                                                </List>
                                        )}
                                    </AutoSizer>
                                </div></AnimatedSymbolGroup>
</wrapper> 
                        );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Symbol;